export default __webpack_public_path__ + "images/ER.27b6cba.png";